import * as Sentry from '@sentry/browser';
import { clientApi } from './clientApi';

export async function getOrganizationData(organizationId) {
  try {
    return await clientApi(`/profile/organization/${organizationId}`, 'GET');
  } catch (e) {
    Sentry.captureException(e);
  }
}

export async function getOrganizationAddresses(organizationId = '') {
  try {
    return await clientApi(
      `/profile/address/organization?organization_id=${organizationId}`,
      'GET',
    );
  } catch (e) {
    Sentry.captureException(e);
  }
}

export async function inviteToOrganization(body) {
  try {
    return await clientApi('/profile/enterprise/invite', 'POST', null, JSON.stringify(body));
  } catch (error) {
    Sentry.captureException(error);
  }
}

export async function getOrganizationInvites(organizationId = '', isPlatformAdmin = false) {
  try {
    return await clientApi(
      `/profile/enterprise/profiles/invites/${organizationId}?is_platform_admin=${isPlatformAdmin}`,
      'GET',
    );
  } catch (error) {
    Sentry.captureException(error);
  }
}

export async function getOrganizationMembers(organizationId = '') {
  try {
    return await clientApi(
      `/profile/organization/profiles_by_organization_id/${organizationId}`,
      'GET',
    );
  } catch (error) {
    Sentry.captureException(error);
  }
}

export async function deleteOrganizationRequest(organizationId) {
  try {
    return await clientApi(`/profile/enterprise/delete_request/${organizationId}`, 'DELETE');
  } catch (error) {
    Sentry.captureException(error);
  }
}

export async function revokeInvite(payload = {}) {
  try {
    return await clientApi(
      '/profile/enterprise/invite/revoke',
      'PATCH',
      null,
      JSON.stringify(payload),
    );
  } catch (error) {
    Sentry.captureException(error);
  }
}

export async function resendInvite(payload = {}) {
  try {
    return await clientApi(
      '/profile/enterprise/invite/resend',
      'PATCH',
      null,
      JSON.stringify(payload),
    );
  } catch (error) {
    Sentry.captureException(error);
  }
}

export async function removeProfileFromEnterprise(body) {
  try {
    return await clientApi('/profile/enterprise/', 'DELETE', null, JSON.stringify(body));
  } catch (error) {
    Sentry.captureException(error);
  }
}

export async function removeProfilesFromOrganization(organizationId = '', payload = {}) {
  try {
    return await clientApi(
      `/license/remove/${organizationId}`,
      'DELETE',
      null,
      JSON.stringify(payload),
    );
  } catch (error) {
    Sentry.captureException(error);
  }
}

export async function updateAddress(organizationId, addressData) {
  try {
    let response = await getOrganizationAddresses(organizationId);

    if (response?.status === 200) {
      if (Array.isArray(response.data) && response.data.length) {
        const existingAddress = response.data.find((address) => address.type === addressData.type);
        if (existingAddress) {
          return await clientApi(
            '/profile/address',
            'PATCH',
            { address_id: existingAddress.id },
            JSON.stringify(addressData),
          );
        }
      }
    }

    response = await clientApi('/profile/address/', 'POST', null, JSON.stringify(addressData));

    if (response?.status === 201) {
      return await clientApi(
        '/profile/address/organization',
        'POST',
        null,
        JSON.stringify({ organization_id: organizationId, address_id: response.data.id }),
      );
    }
  } catch (e) {
    Sentry.captureException(e);
  }
}

export async function deleteOrganizationAddress(organizationId) {
  try {
    return await clientApi(`/profile/address/delete_from_organization/${organizationId}`, 'DELETE');
  } catch (e) {
    Sentry.captureException(e);
  }
}

export async function updateOrganization(organizationId = '', payload = {}) {
  try {
    return await clientApi(
      `/profile/organization/${organizationId}`,
      'PATCH',
      null,
      JSON.stringify(payload),
    );
  } catch (e) {
    Sentry.captureException(e);
  }
}

export async function updateLinkedProfile(profileId, body) {
  try {
    return await clientApi(`/license/update/${profileId}`, 'PATCH', null, JSON.stringify(body));
  } catch (e) {
    Sentry.captureException(e);
  }
}

export async function getAdminOrganizationId(profileId) {
  try {
    return await clientApi(`/profile/enterprise/admin_organization_id/${profileId}`, 'GET');
  } catch (e) {
    Sentry.captureException(e);
  }
}

export async function getOrganizationBundle(organizationId) {
  try {
    return await clientApi(`/license/organization_bundle/${organizationId}`, 'GET');
  } catch (e) {
    Sentry.captureException(e);
  }
}

export async function getInviteTabelSeatCount(organizationId = '') {
  try {
    return await clientApi(`/profile/enterprise/invite_tabel/seats/${organizationId}`, 'GET');
  } catch (error) {
    Sentry.captureException(error);
  }
}
